import { zetApi } from '@zet/network'

import { ILeadsFilterDto } from '../types'

const getLeadsFilterDto = (filterDto: ILeadsFilterDto) => {
  return encodeURIComponent(JSON.stringify(filterDto))
}

export async function fetchBrandLeads(
  offset = 0,
  searchText?: string | undefined
) {
  const response = await zetApi.get(
    `leads?filters=${getLeadsFilterDto({
      pagination: {
        offset: offset,
        limit: 10,
      },
      searchText: searchText as string,
      filters: [],
    })}`
  )

  return { nextOffset: offset + 10, ...response.data?.data }
}
